export default __webpack_public_path__ + "static/media/ITR.ea45ad01.png";